module.exports = __webpack_public_path__ + "img/brush-red.a9ecb8f6.png";